export const isMobile = (): boolean => window.innerWidth < 1200
